export enum groupMembershipActions {
  JOIN = 'join',
  LEAVE = 'leave',
}
